export default __webpack_public_path__ + "static/media/9.a753d488.png";